import { CancelTokenSource } from 'axios';
import {
  ConsultationDto,
  ConsultationEntryDto,
  MedicamentPrintLabelDto,
  UpsertConsultationDto
} from 'ts-types/api.types';
import axios from './http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/consultations`;

export const getAllConsultationsByTreatmentId = (
    treatmentId: number,
    source: CancelTokenSource): Promise<Array<ConsultationDto>> => {

  return axios
      .get(`${apiUri}/${treatmentId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAllConsultationEntriesByConsultationId = (
    consultationId: number,
    source: CancelTokenSource): Promise<Array<ConsultationEntryDto>> => {

  return axios
      .get(`${apiUri}/entries/${consultationId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getUpsertConsultationById = (
    consultationId: number,
    source: CancelTokenSource): Promise<UpsertConsultationDto> => {

  return axios
      .get(
          `${apiUri}/consultation`,
          {
            params: {consultationId: consultationId},
            cancelToken: source.token
          })
      .then(response => response.data);
};

export const saveConsultation = (
    upsertConsultationDto: Partial<UpsertConsultationDto>,
    source: CancelTokenSource): Promise<ConsultationDto> => {

  return axios
      .post(apiUri, upsertConsultationDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editConsultation = (
    upsertConsultationDto: Partial<UpsertConsultationDto>,
    consultationId: number,
    source: CancelTokenSource): Promise<ConsultationDto> => {

  return axios
      .put(`${apiUri}/${consultationId}`, upsertConsultationDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteConsultationById = (
    consultationId: number,
    source: CancelTokenSource): Promise<ConsultationDto> => {
  
  return axios
      .delete(`${apiUri}/${consultationId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const printMedicamentLabel = (
    consultationEntryId: number,
    patientId: number,
    source: CancelTokenSource): Promise<MedicamentPrintLabelDto> => {

  return axios
      .get(`${apiUri}/print-medicament/${consultationEntryId}`,
          {params: {patientId: patientId}, cancelToken: source.token})
      .then(response => response.data);
}
